import axios from 'axios';
import md5 from 'md5';
import store from '../store';
import config from '../config/config';
axios.defaults.timeout = 15000;
axios.defaults.baseURL = config.apiServer;
axios.interceptors.request.use((config) => {
  const token = store.getters.getterToken;
  if (token !== null) {
    config.headers.token = token;
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  return config;
}, (error) => {
  loadinginstace.close();
  return Promise.reject(error);
})

axios.interceptors.response.use((response) => {
  const newToken = response.headers.token;
  if (newToken !== undefined) {
    // 保存新的Token
    store.commit('SET_DOCTOR_TOKEN', newToken);
  }
  if (response && response.data && /^TOKEN.*$/.test(response.data.error)) {
    // TOKEN出现问题，需要清空本地Token
    store.commit('CLEAR_CLINIC_TOKEN');
  }
  return response;
}, error => Promise.reject(error));

/**
 * 生成随机字符串
 */
function rand() {
  return Math.random().toString(36).substr(2);
}

export default {
  /**
   * 生成签名
   * @param params 参数列表
   */
  makeSign(params) {
    const keyList = [];
    Object.keys(params).forEach((key) => {
      keyList.push(key);
    });
    keyList.sort();
    let tempStr = '';
    keyList.forEach((key) => {
      tempStr += params[key];
    });
    return md5(tempStr + config.apiAppSecret);
  },
  /**
   * 生成接口调用URL
   * @param uri 接口URI
   * @param params 参数列表
   * @returns string
   */
  makeUrl(uri, params) {
    if (params === undefined || params == null) {
      params = {};
    }
    if (uri.indexOf('?') > -1) {
      uri.substr(uri.indexOf('?') + 1).split('&').forEach((p1) => {
        const p2 = p1.split('=');
        params[p2[0]] = decodeURIComponent(p2[1]);
      });
    }
    params.appid = config.apiAppId;
    params.nonce = rand();
    params.timestamp = parseInt((new Date()).getTime() / 1000, 10);
    params.version = config.apiVersion;
    const sign = this.makeSign(params);
    const queryList = [];
    Object.keys(params).forEach((key) => {
      queryList.push(`${key}=${encodeURIComponent(params[key])}`);
    });
    queryList.push(`sign=${sign}`);
    return config.apiServer + uri + (uri.indexOf('?') > -1 ? '&' : '?') + queryList.join('&');
  },
  /**
   * 发送Api Get请求
   * @param uri 接口URI
   * @param params
   */
  get(uri, params) {
    const url = this.makeUrl(uri, params);
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        const json = response.data;
        if (json.error !== undefined && json.error === '') {
          resolve(json);
        } else {
          reject(json);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 发送Api Post请求
   * @param uri 接口URI
   * @param json
   */
  post(uri, json) {
    const url = this.makeUrl(uri, null);
    return new Promise((resolve, reject) => {
      axios.post(url, json, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
        const json = response.data;
        if (json.error !== undefined && json.error === '') {
          resolve(json);
        } else {
          reject(json);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  },
}


// WEBPACK FOOTER //
// ./src/api/config.js